<div class="sso-connections">
  <header class="page-head">
    <div>
      <p class="eyebrow">Admin</p>
      <h1>SSO connections</h1>
      <p class="lede">
        Let VIVE staff, or a client's team, sign in with their own identity
        provider.
      </p>
    </div>
    <div class="actions">
      <button
        type="button"
        class="btn btn-outline btn-sm"
        (click)="addConnection()"
      >
        <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>
        Add connection
      </button>
    </div>
  </header>

  @if (loading) {
    <div class="spinner-border text-secondary" role="status">
      <span class="visually-hidden">Loading</span>
    </div>
  } @else if (loadError) {
    <div class="alert alert-danger" role="alert">{{ loadError }}</div>
  } @else {
    @if (actionError) {
      <div class="alert alert-danger" role="alert">{{ actionError }}</div>
    }

    @if (connections.length === 0) {
      <section
        class="sso-connections__empty"
        aria-labelledby="sso-connections-empty"
      >
        <h2 id="sso-connections-empty">No SSO connections yet.</h2>
      </section>
    } @else {
      <div class="sso-connections__table-wrap">
        <table class="sso-connections__table">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Protocol</th>
              <th scope="col">For</th>
              <th scope="col">Domains</th>
              <th scope="col">Status</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            @for (connection of connections; track connection.id) {
              <tr>
                <td>
                  <strong>{{ connection.name }}</strong>
                </td>
                <td>{{ protocolLabels[connection.protocol] }}</td>
                <td>{{ forLabel(connection) }}</td>
                <td>{{ domainsLabel(connection) }}</td>
                <td>
                  <span
                    [class]="'chip ' + statusChips[connection.status].className"
                    >{{ statusChips[connection.status].label }}</span
                  >
                </td>
                <td>
                  <div class="sso-connections__actions">
                    <a
                      class="btn btn-ghost btn-sm"
                      [routerLink]="[
                        '/admin',
                        'admin',
                        'sso-connections',
                        connection.id
                      ]"
                      >Open</a
                    >
                    @if (connection.status === 'active') {
                      <button
                        type="button"
                        class="btn btn-ghost btn-sm"
                        [disabled]="busyConnectionId !== null"
                        (click)="disable(connection)"
                      >
                        Disable
                      </button>
                    } @else {
                      <!-- A disabled button fires no mouse events, so the tooltip sits on a wrapper. -->
                      <span
                        [title]="
                          hasDomainAndMapping(connection)
                            ? ''
                            : 'Add a domain and a role mapping first.'
                        "
                      >
                        <button
                          type="button"
                          class="btn btn-ghost btn-sm"
                          [disabled]="
                            busyConnectionId !== null ||
                            !hasDomainAndMapping(connection)
                          "
                          (click)="activate(connection)"
                        >
                          Activate
                        </button>
                      </span>
                    }
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  }
</div>
